import dayjs from 'dayjs';
import { Utils, MockHandler } from '@gv/triage-components';

import { URL } from 'api/constants';
import { Pet, Severity, Hospital, AppointmentTime } from 'types';

import { ListFilter } from './types';

const { getTimeData } = Utils.Date;

let hospitalData: Hospital[] = [
  {
    id: 2,
    city: 'Chicago',
    name: 'New Animal Hospital & Paws Clinic',
    address: 'Chicago, Low town, 1 avenue, building 23',
    appointments: [
      {
        id: 12313124,
        gvFee: 150000,
        pet: Object.values(Pet),
        severity: Severity.Appointment,
        date: new Date().toISOString(),
        time: [
          { id: 14, start: 0, end: 30000 },
          { id: 15, end: 1800000, start: 900000 },
          { id: 16, end: 3600000, start: 1800000 },
          { id: 17, end: 5400000, start: 3600000 },
          { id: 18, end: 61200000, start: 59400000 },
          { id: 19, end: 63000000, start: 61200000 },
          { id: 20, end: 64800000, start: 63000000 },
        ],
      },
      {
        id: 1234,
        gvFee: 5000,
        severity: Severity.Emergency,
        date: new Date().toISOString(),
        pet: [Pet.Cat, Pet.Dog, Pet.PocketPet],
        time: [
          { id: 21, end: 0, start: 30000 },
          { id: 22, end: 1800000, start: 900000 },
          { id: 23, end: 3600000, start: 1800000 },
          { id: 24, end: 5400000, start: 3600000 },
          { id: 612, end: 63000000, start: 61200000 },
          { id: 7151, end: 64800000, start: 63000000 },
        ],
      },
      {
        id: 7777715,
        gvFee: 5000,
        pet: Object.values(Pet),
        severity: Severity.Urgent,
        date: new Date().toISOString(),
        time: [
          { id: 25, end: 39600000, start: 36000000 },
          { id: 26, end: 61200000, start: 59400000 },
          { id: 265, end: 81000000, start: 79200000 },
        ],
      },
    ],
  },
  {
    id: 1,
    city: 'Chicago',
    name: 'Animal Hospital of Chicago',
    address: 'Chicago, River North, 7 avenue, building 1',
    logo: 'https://assets-global.website-files.com/63a9fb94e473f36dbe99c1b1/651bc933da4c4809317d9721_kXa8JqIBRnCMtZnHkb1u.png',
    appointments: [
      {
        gvFee: 1500,
        id: 12313124,
        pet: Object.values(Pet),
        severity: Severity.Appointment,
        date: new Date().toISOString(),
        time: [
          { id: 1, start: 0, end: 30000 },
          { id: 2, end: 1800000, start: 900000 },
          { id: 3, end: 3600000, start: 1800000 },
          { id: 4, end: 5400000, start: 3600000 },
          { id: 5, end: 61200000, start: 59400000 },
          { id: 6, end: 63000000, start: 61200000 },
          { id: 7, end: 64800000, start: 63000000 },
        ],
      },
      {
        id: 1234,
        gvFee: 5000,
        severity: Severity.Emergency,
        date: new Date().toISOString(),
        pet: [Pet.Cat, Pet.Dog, Pet.PocketPet],
        time: [
          { id: 8, end: 0, start: 30000 },
          { id: 9, end: 1800000, start: 900000 },
          { id: 10, end: 3600000, start: 1800000 },
          { id: 11, end: 5400000, start: 3600000 },
          { id: 62, end: 63000000, start: 61200000 },
          { id: 71, end: 64800000, start: 63000000 },
          { id: 124, end: 52200000, start: 50400000 },
        ],
      },
      {
        id: 7777715,
        gvFee: 5000,
        pet: Object.values(Pet),
        severity: Severity.Urgent,
        date: new Date().toISOString(),
        time: [
          { id: 12, end: 39600000, start: 36000000 },
          { id: 13, end: 61200000, start: 59400000 },
          { id: 139, end: 55800000, start: 54000000 },
        ],
      },
    ],
  },
  {
    id: 3,
    city: 'Chicago',
    name: 'Paws & Claws Clinic',
    address: 'Chicago, Lakeview, 3rd Street, building 5',
    logo: 'https://st2.depositphotos.com/4362315/7819/v/450/depositphotos_78194048-stock-illustration-medical-logo-health-care-center.jpg',
    appointments: [
      {
        id: 112233,
        gvFee: 2000,
        pet: [Pet.Dog, Pet.Cat],
        severity: Severity.Emergency,
        date: new Date().toISOString(),
        time: [
          { id: 27, start: 0, end: 30000 },
          { id: 28, end: 3600000, start: 1800000 },
          { id: 29, end: 5400000, start: 3600000 },
          { id: 30, end: 7200000, start: 5400000 },
          { id: 31, end: 9000000, start: 7200000 },
        ],
      },
      {
        id: 223344,
        gvFee: 6000,
        pet: [Pet.Cat],
        severity: Severity.Appointment,
        date: new Date().toISOString(),
        time: [
          { id: 32, end: 1800000, start: 900000 },
          { id: 33, end: 3600000, start: 1800000 },
          { id: 34, end: 5400000, start: 3600000 },
          { id: 35, end: 7200000, start: 5400000 },
        ],
      },
    ],
  },
  {
    id: 4,
    city: 'Chicago',
    name: 'Furry Friends Hospital',
    address: 'Chicago, Uptown, 1st Avenue, building 2',
    logo: 'https://media.istockphoto.com/id/1624291952/vector/medical-health-logo-design-illustration.jpg?s=612x612&w=0&k=20&c=RdOq1SRcWwS_12_c5Zg2_QOUz1GD-YwGvfRodtOPN5w=',
    appointments: [
      {
        id: 334455,
        gvFee: 3000,
        pet: [Pet.Dog],
        severity: Severity.Urgent,
        date: new Date().toISOString(),
        time: [
          { id: 36, start: 0, end: 30000 },
          { id: 37, end: 3600000, start: 1800000 },
          { id: 38, end: 5400000, start: 3600000 },
          { id: 39, end: 7200000, start: 5400000 },
          { id: 40, end: 9000000, start: 7200000 },
        ],
      },
      {
        id: 445566,
        gvFee: 7000,
        pet: [Pet.PocketPet],
        severity: Severity.Appointment,
        date: new Date().toISOString(),
        time: [
          { id: 41, end: 1800000, start: 900000 },
          { id: 42, end: 3600000, start: 1800000 },
          { id: 43, end: 5400000, start: 3600000 },
          { id: 44, end: 7200000, start: 5400000 },
        ],
      },
    ],
  },
  {
    id: 5,
    city: 'Chicago',
    name: 'Healthy Paws Clinic',
    address: 'Chicago, West Loop, 10th Street, building 8',
    logo: 'https://d1csarkz8obe9u.cloudfront.net/posterpreviews/hospital-logo-design-template-448484affbfab31292f9307abd0a95b1_screen.jpg?ts=1676290785',
    appointments: [
      {
        id: 556677,
        gvFee: 2500,
        pet: [Pet.Exotic],
        severity: Severity.Emergency,
        date: dayjs().add(1, 'day').toISOString(),
        time: [
          { id: 45, start: 0, end: 30000 },
          { id: 46, end: 3600000, start: 1800000 },
          { id: 47, end: 5400000, start: 3600000 },
          { id: 48, end: 7200000, start: 5400000 },
          { id: 49, end: 9000000, start: 7200000 },
        ],
      },
      {
        id: 667788,
        gvFee: 8000,
        pet: [Pet.Equine],
        severity: Severity.Appointment,
        date: dayjs().add(1, 'day').toISOString(),
        time: [
          { id: 50, end: 1800000, start: 900000 },
          { id: 51, end: 3600000, start: 1800000 },
          { id: 52, end: 5400000, start: 3600000 },
          { id: 53, end: 7200000, start: 5400000 },
        ],
      },
    ],
  },
  {
    id: 6,
    city: 'Chicago',
    name: 'Pet Wellness Center',
    address: 'Chicago, South Loop, 20th Avenue, building 10',
    appointments: [
      {
        id: 778899,
        gvFee: 3500,
        pet: [Pet.Dog, Pet.Cat],
        severity: Severity.Unknown,
        date: dayjs().add(1, 'day').toISOString(),
        time: [
          { id: 54, start: 0, end: 30000 },
          { id: 55, end: 3600000, start: 1800000 },
          { id: 56, end: 5400000, start: 3600000 },
          { id: 57, end: 7200000, start: 5400000 },
          { id: 58, end: 9000000, start: 7200000 },
        ],
      },
      {
        id: 889900,
        gvFee: 9000,
        pet: [Pet.Exotic],
        severity: Severity.Appointment,
        date: dayjs().add(1, 'day').toISOString(),
        time: [
          { id: 59, end: 1800000, start: 900000 },
          { id: 60, end: 3600000, start: 1800000 },
          { id: 61, end: 5400000, start: 3600000 },
          { id: 62, end: 7200000, start: 5400000 },
        ],
      },
    ],
  },
  {
    id: 7,
    city: 'Chicago',
    name: 'Happy Tails Hospital',
    address: 'Chicago, Lincoln Park, 15th Street, building 3',
    appointments: [
      {
        id: 990011,
        gvFee: 4000,
        severity: Severity.Emergency,
        pet: [Pet.Dog, Pet.PocketPet],
        date: dayjs().add(1, 'day').toISOString(),
        time: [
          { id: 63, start: 0, end: 30000 },
          { id: 64, end: 3600000, start: 1800000 },
          { id: 65, end: 5400000, start: 3600000 },
          { id: 66, end: 7200000, start: 5400000 },
          { id: 67, end: 9000000, start: 7200000 },
        ],
      },
      {
        id: 110022,
        gvFee: 10000,
        pet: [Pet.Equine],
        severity: Severity.Appointment,
        date: dayjs().add(1, 'day').toISOString(),
        time: [
          { id: 68, end: 1800000, start: 900000 },
          { id: 69, end: 3600000, start: 1800000 },
          { id: 70, end: 5400000, start: 3600000 },
          { id: 71, end: 7200000, start: 5400000 },
        ],
      },
    ],
  },
];

/**
 * Finds the 5 closest time entries in the array centered around the selected item.
 */
const findClosestItems = (array: AppointmentTime[], selectedItem: number) => {
  const arrayCopy = [...array];

  arrayCopy.sort((a, b) => a.start - b.start);

  const index = arrayCopy.findIndex((item) => item.start === selectedItem);

  let startIndex = Math.max(0, index - 2);
  let endIndex = Math.min(arrayCopy.length, index + 3);

  if (endIndex - startIndex < 5) {
    if (startIndex === 0) {
      endIndex = Math.min(arrayCopy.length, startIndex + 5);
    } else {
      startIndex = Math.max(0, endIndex - 5);
    }
  }
  return arrayCopy.slice(startIndex, endIndex);
};

/**
 * Filters the appointments based on the given criteria and modifies the time array.
 */
const filterAppointments = (
  hospitals: Hospital[],
  filter: Partial<ListFilter>
): Hospital[] => {
  console.log('filter', filter);

  const isEmergencyOrUrgent =
    filter.severity === Severity.Emergency ||
    filter.severity === Severity.Urgent;

  const filteredHospitals: Hospital[] = hospitals
    .map((hospital) => {
      let filteredAppointments = hospital.appointments;

      if (filter.severity) {
        filteredAppointments = filteredAppointments.filter(
          (appointment) => appointment.severity === filter.severity
        );
      }

      if (filter.pet) {
        filteredAppointments = filteredAppointments.filter((appointment) =>
          appointment.pet.includes(filter.pet as Pet)
        );
      }

      if (filter.date) {
        filteredAppointments = filteredAppointments.filter((appointment) =>
          dayjs(appointment.date).isSame(filter.date, 'day')
        );
      }

      if (typeof filter.time === 'number') {
        const filterTime = filter.time;
        if (isEmergencyOrUrgent) {
          // For Emergency and Urgent severities, filter times greater than the current time and sorted in ascending order.
          const sortedTime = filteredAppointments.filter((appointment) =>
            appointment.time.some((time) => time.start >= filterTime)
          );
          const appointmentsWithValidTime = sortedTime.map((appointment) => {
            const validTimes = appointment.time.filter(
              (time) => time.start >= filterTime
            );
            // Sort valid times in ascending order and slice the first 5
            return {
              ...appointment,
              time: validTimes.sort((a, b) => a.start - b.start).slice(0, 5),
            };
          });

          filteredAppointments = appointmentsWithValidTime.sort(
            (a, b) => a.time[0].start - b.time[0].start
          );
        } else {
          // For other severities, find the appointments with exact start time and get the closest 5 items
          const timeNow = getTimeData(new Date());
          const isToday = dayjs(filter.date).isToday();

          const appointmentsWithSameTime = filteredAppointments.filter(
            (appointment) =>
              appointment.time.some((time) => time.start === filterTime)
          );

          filteredAppointments = appointmentsWithSameTime.map((appointment) => {
            let validTimes = appointment.time;
            if (isToday) {
              // Filter out past times if the date is today
              validTimes = validTimes.filter((time) => time.start >= timeNow);
            }
            return {
              ...appointment,
              time: findClosestItems(validTimes, filterTime),
            };
          });
        }
      }

      return {
        ...hospital,
        appointments: filteredAppointments,
      };
    })
    .filter((hospital) => hospital.appointments.length);

  const sortedHospitals = isEmergencyOrUrgent
    ? // Sort hospitals by closest time
      filteredHospitals.sort((a, b) => {
        const getClosestTime = (hospital: Hospital) =>
          Math.min(
            ...hospital.appointments.flatMap((appt) =>
              appt.time.map((time) => time.start)
            )
          );
        return getClosestTime(a) - getClosestTime(b);
      })
    : // Sort hospitals by price
      filteredHospitals.sort((a, b) => {
        const getMinFee = (hospital: Hospital) =>
          Math.min(...hospital.appointments.map((appt) => appt.gvFee));
        return getMinFee(b) - getMinFee(a);
      });

  return sortedHospitals;
};

export const appointmentApiHandlers: MockHandler[] = [
  {
    method: 'get',
    url: URL.APPOINTMENT_LIST,
    responseFunc: ({ data }) => ({
      data: filterAppointments(hospitalData, data.filters),
    }),
  },
];
